import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup,Validators} from "@angular/forms";
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-add-ecowas-in-config',
  templateUrl: './add-ecowas-in-config.component.html',
  styleUrls: ['./add-ecowas-in-config.component.scss']
})
export class AddEcowasInConfigComponent implements OnInit {

  addEcowasinFormGroup:FormGroup;
  submitted:boolean;

  constructor(private formBuilder: FormBuilder,
    private endpointsService: EndpointsService,
    private backendApiService: BackendApiService,
    private spinnerService:Ng4LoadingSpinnerService,
    private router:Router) { }

  ngOnInit(): void {
    this.addEcowasInCon()
  }
addEcowasInCon(){
  this.addEcowasinFormGroup = this.formBuilder.group({
    // orgId:[sessionStorage.getItem('orgIdv')],
    orgId:[],
    service_name:[],
    spId:[],
    productId:[],
    serviceId:[],
    password:[],
    username:[],
    host:['UGW_TEST'],
    url:['http://172.30.194.178:10010/Air'],
    offerId:[],
    
    deActUrl:['http://172.30.194.146:9000/cisBusiness/service/fulfillmentService'],
    hlrLoginCommand:['LOGIN:rrms:Proliant@2022'],
    blockSmsCommand:['SET:HLRSUB:MSISDN,22996812323:TS22,0'],
    blockInternetCommand:['SET:HLRSUB:MSISDN,@@:NAM,1,KEEP,1'],
    unblockSmsCommand:['SET:HLRSUB:MSISDN,@@:TS22,1'],
    unblockInternetCommand:['SET:HLRSUB:MSISDN,@@:NAM,0,KEEP,1'],
    hlrIP:[],
    hlrPort:['3300'],
    blockInternetCommand1:[],
    unblockInternetCommand1:[],
    locCheckCmd:['GET:HLRSUB:MSISDN,@@:VLRID']

  })
}
onAdd(){
  // this.submitted=true;
  // if(this.addEcowasinFormGroup.invalid){
  //   return;
  // }
  this.backendApiService.callToApi(this.endpointsService.URL_ADD_ECOWAS_IN_CONFIG +
    '&service_name=' + this.addEcowasinFormGroup.get('service_name').value+
    '&spId=' + this.addEcowasinFormGroup.get('spId').value+
    '&productId=' + this.addEcowasinFormGroup.get('productId').value+
    '&serviceId=' + this.addEcowasinFormGroup.get('serviceId').value+
    '&password=' + this.addEcowasinFormGroup.get('password').value+
    '&username=' + this.addEcowasinFormGroup.get('username').value+
    '&host=' + this.addEcowasinFormGroup.get('host').value+
    '&url=' + this.addEcowasinFormGroup.get('url').value+
    '&offerId=' + this.addEcowasinFormGroup.get('offerId').value+
    '&orgId=' + this.addEcowasinFormGroup.get('orgId').value+
    '&deActUrl=' + this.addEcowasinFormGroup.get('deActUrl').value+
    '&hlrLoginCommand=' + this.addEcowasinFormGroup.get('hlrLoginCommand').value+
    '&blockSmsCommand=' + this.addEcowasinFormGroup.get('blockSmsCommand').value+
    '&blockInternetCommand=' + this.addEcowasinFormGroup.get('blockInternetCommand').value+
    '&unblockSmsCommand=' + this.addEcowasinFormGroup.get('unblockSmsCommand').value+
    '&unblockInternetCommand=' + this.addEcowasinFormGroup.get('unblockInternetCommand').value+
    '&hlrIP=' + this.addEcowasinFormGroup.get('hlrIP').value+
    '&hlrPort=' + this.addEcowasinFormGroup.get('hlrPort').value+
    '&blockInternetCommand1=' + this.addEcowasinFormGroup.get('blockInternetCommand1').value+
    '&unblockInternetCommand1=' + this.addEcowasinFormGroup.get('unblockInternetCommand1').value+
    '&locCheckCmd=' + this.addEcowasinFormGroup.get('locCheckCmd').value
    
   

    )
    .subscribe(response => {
      console.log("responseeee",response)
      // if (response === null  || response === '{"status" : "false"}') {
      //   alert('Not Added');
        

      //   return;
      // }
      // else if( response === '{"status" : "Record with orgId already exists"}'){
      //   alert("Record with orgid already exit")
      // }else {
        alert('Add successfully');        
        this.spinnerService.show();
        this.router.navigate(['/service-live-dashboard/rrms-service-live-dashboard']).then()
    //  }
})
}
}
